/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type { SortedTroves, SortedTrovesInterface } from "../SortedTroves";

const _abi = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "_borrowerOperationsAddress",
        type: "address",
      },
    ],
    name: "BorrowerOperationsAddressChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "_id",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "_NICR",
        type: "uint256",
      },
    ],
    name: "NodeAdded",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "_id",
        type: "address",
      },
    ],
    name: "NodeRemoved",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "_sortedDoublyLLAddress",
        type: "address",
      },
    ],
    name: "SortedTrovesAddressChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "_troveManagerAddress",
        type: "address",
      },
    ],
    name: "TroveManagerAddressChanged",
    type: "event",
  },
  {
    inputs: [],
    name: "NAME",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "borrowerOperationsAddress",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        internalType: "address",
        name: "_id",
        type: "address",
      },
    ],
    name: "contains",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "data",
    outputs: [
      {
        internalType: "address",
        name: "head",
        type: "address",
      },
      {
        internalType: "address",
        name: "tail",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "maxSize",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "size",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_NICR",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "_prevId",
        type: "address",
      },
      {
        internalType: "address",
        name: "_nextId",
        type: "address",
      },
    ],
    name: "findInsertPosition",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
    ],
    name: "getFirst",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
    ],
    name: "getLast",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
    ],
    name: "getMaxSize",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        internalType: "address",
        name: "_id",
        type: "address",
      },
    ],
    name: "getNext",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        internalType: "address",
        name: "_id",
        type: "address",
      },
    ],
    name: "getPrev",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
    ],
    name: "getSize",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        internalType: "address",
        name: "_id",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_NICR",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "_prevId",
        type: "address",
      },
      {
        internalType: "address",
        name: "_nextId",
        type: "address",
      },
    ],
    name: "insert",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
    ],
    name: "isEmpty",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
    ],
    name: "isFull",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "isInitialized",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        internalType: "address",
        name: "_id",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_newNICR",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "_prevId",
        type: "address",
      },
      {
        internalType: "address",
        name: "_nextId",
        type: "address",
      },
    ],
    name: "reInsert",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        internalType: "address",
        name: "_id",
        type: "address",
      },
    ],
    name: "remove",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_troveManagerAddress",
        type: "address",
      },
      {
        internalType: "address",
        name: "_borrowerOperationsAddress",
        type: "address",
      },
    ],
    name: "setParams",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "troveManager",
    outputs: [
      {
        internalType: "contract ITroveManager",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_NICR",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "_prevId",
        type: "address",
      },
      {
        internalType: "address",
        name: "_nextId",
        type: "address",
      },
    ],
    name: "validInsertPosition",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
] as const;

const _bytecode =
  "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";

type SortedTrovesConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: SortedTrovesConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class SortedTroves__factory extends ContractFactory {
  constructor(...args: SortedTrovesConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override deploy(
    overrides?: Overrides & { from?: string }
  ): Promise<SortedTroves> {
    return super.deploy(overrides || {}) as Promise<SortedTroves>;
  }
  override getDeployTransaction(
    overrides?: Overrides & { from?: string }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  override attach(address: string): SortedTroves {
    return super.attach(address) as SortedTroves;
  }
  override connect(signer: Signer): SortedTroves__factory {
    return super.connect(signer) as SortedTroves__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): SortedTrovesInterface {
    return new utils.Interface(_abi) as SortedTrovesInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): SortedTroves {
    return new Contract(address, _abi, signerOrProvider) as SortedTroves;
  }
}
